<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <div id="printMe">
        <v-card>
          <v-toolbar dark color="green">
            <v-toolbar-title>Asignación de Mano de Obra (EI 130)</v-toolbar-title>
            <v-spacer></v-spacer>
            <button v-print="'#printMe'"><v-icon>mdi-printer</v-icon></button>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <!-- <v-btn icon @click="printinforme">
              <v-icon>mdi-printer</v-icon>
            </v-btn> -->
          </v-toolbar>
          <v-card-text>
            <v-row dense>
              <v-col cols="4" sm="6" md="1">
                <h6>Código: {{ codgral }}</h6>
              </v-col>
              <v-col cols="4" sm="6" md="2">
                <h6>Fecha: {{ listado.fecha }}</h6>
              </v-col>
              <v-col cols="4" sm="6" md="3">
                <h6>Nombre: {{ nombre }}</h6>
              </v-col>
              <v-col cols="4" sm="6" md="3">
                <h6>Resp. Trabajo: {{ listado.resptrabajo }}</h6>
              </v-col>
              <v-col cols="4" sm="6" md="3">
                <h6>Resp. Área: {{ listado.resparea }}</h6>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4" sm="6" md="3">
                <h6>Obra/Servicio: {{ listado.obra }}</h6>
              </v-col>
              <v-col cols="4" sm="6" md="3">
                <h6>Lugar: {{ listado.lugar }}</h6>
              </v-col>
              <v-col cols="4" sm="6" md="2">
                <h6>N° OT: {{ listado.numot }}</h6>
              </v-col>
              <v-col cols="3" sm="6" md="1">
                <h6>Quincena: {{ listado.quincena }}</h6>
              </v-col>
              <v-col cols="3" sm="6" md="1">
                <h6>Mes: {{ listado.mes }}</h6>
              </v-col>
              <v-col cols="3" sm="6" md="1">
                <h6>Año: {{ listado.anio }}</h6>
              </v-col>
              <v-col cols="3" sm="6" md="1">
                <h6>Vehículo: {{ listado.dominio }}</h6>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row justify="center">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Día
                    </th>
                    <th class="text-left">
                      Hora Entrada
                    </th>
                    <th class="text-left">
                      Hora Salida
                    </th>
                    <th class="text-left">
                      Enfermedad
                    </th>
                    <th class="text-left">
                      Hora Altura
                    </th>
                    <th class="text-left">
                      Hora H° A°
                    </th>
                    <th class="text-left">
                      Hora Zanjeo
                    </th>
                    <th class="text-left">
                      Almuerzo entrada
                    </th>
                    <th class="text-left">
                      Almuerzo Salida
                    </th>
                    <th class="text-left">
                      Comida pagada por icssa
                    </th>
                    <th class="text-left">
                      Trabajó a + de 10km
                    </th>
                    <th class="text-left">
                      Manejó
                    </th>
                    <th class="text-left">
                      Observaciones
                    </th>
                    <th class="text-left">
                      Imputación
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in listado.detalle" :key="item.id">
                    <td>{{ item.dia }}</td>
                    <td>{{ item.horae }}</td>
                    <td>{{ item.horas }}</td>
                    <td>{{ item.enfer }}</td>
                    <td>{{ item.horaa }}</td>
                    <td>{{ item.horah }}</td>
                    <td>{{ item.horaz }}</td>
                    <td>{{ item.almuerzoe }}</td>
                    <td>{{ item.almuerzos }}</td>
                    <td>{{ item.comida }}</td>
                    <td>{{ item.distancia }}</td>
                    <td>{{ item.manejo }}</td>
                    <td>{{ item.observ }}</td>
                    <td>{{ item.imput }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-card>
      </div>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "../../../axios-auth";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import print from 'vue-print-nb';

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    listado: [],
  }),
  directives: {
    print
  },
  props: ["visible", "codgral", "nombre"],

  computed: {
    show: {
      get() {
        this.buscarDatosAsig();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarInforme();
          console.log("cerrado");
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarInforme() {
      this.listado = [];
    },
    printinforme() { },
    buscarDatosAsig() {
      this.vaciarInforme();
      const codgral = this.codgral;
      if (codgral != null) {
        let self = this;
        axios
          .get("/App/CargarInformeAsig?", {
            params: {
              codgral: codgral,
            },
          })
          .then((response) => {
            self.listado = response.data;
          })
          .catch((error) => {
            self.listado = [];
            console.log(error);
          });
      }
    },
  },
};
</script>
